module.exports = __webpack_public_path__ + "static/media/health-benefits-blog.791253bc.md";